export const projectScheduleImportTranslationsEn = {
  facts: {
    importFact1:
      'The koppla import detects your company’s standardized trades and assigns them automatically.',
    importFact2:
      'We read your .mpp file structure and automatically map the sections, activities, and dependencies to the koppla data model.',
    importFact3:
      'While importing, we scan your .mpp plan for existing collisions and inform you about them afterwards.',
    importFact4:
      'Duration, start/end dates and dependency types (FS/SS/FF/SF) are recognized and converted into koppla logic.',
    importFact5: 'Milestones in .mpp are 1:1 milestones in koppla!',
    importFact6: 'Buffer times are calculated and represented as planable leeway in koppla.',
    importFact7:
      'Columns not needed by koppla are removed. Only the essential fields remain streamlined.',
    importFact8:
      'All your working-time calendars and assignments of activities to specific calendars are preserved.',
    importFact9:
      'Hourly activities are converted into daily activities - this simplifies planning, but can also lead to new collisions after the import.',
    importFact10:
      'To carry over existing trades from your plan, make sure that a column named “Trade” exists.',
    importFact11:
      'Goodbye Gantt scheduling! koppla converts your Gantt-based plan into a typical koppla plan, which provides a better overview.',
    importFact12:
      'Activities that do not fit into the recognized structure are summarized in a “Miscellaneous” row.',
    importFact13:
      'Your plan is checked for invalid dependencies (e.g. loops) and we inform you about them.',
  },
  fakes: {
    importProgressStep1: 'File is being read...',
    importProgressStep2: 'Phases and domains are being identified...',
    importProgressStep3: 'Construction site setup is being generated...',
    importProgressStep4: 'Shell construction is being generated...',
    importProgressStep5: 'Building envelope is being generated...',
    importProgressStep6: 'Fitout is being generated...',
    importProgressStep7: 'Other is being generated...',
    importProgressStep8: 'Milestones are being assigned...',
    importProgressStep9: 'Dependencies are being added...',
    importProgressStep10: 'Import is being completed...',
  },
  helpLink: 'Learn more about the import',
  import: {
    failed: 'Schedule import failed',
    inProgress: 'Schedule import in progress...',
    success: 'Schedule import successful',
    successDescription: 'Please refresh the page to get started!',
    estimatedTime: 'Estimated remaining time',
    stillProcessing: 'Still processing, almost there...',
  },
  onboardingStepper: {
    hint: "koppla projects work more efficiently than traditional platforms, so your project will be transformed into the koppla format. We'll be here to guide you through the process.",
    hintLink: 'Learn more about how imports work',
    stepXofY: 'Step {x} of {y}',
    title: 'Import project',
  },
  stepOneDescription: 'Import your .mpp file to get your project started',
  stepTwo: {
    description: 'Select the type of construction your project will manage',
    residential: 'Residential',
    industrial: 'Industrial',
    road: 'Road',
    bridge: 'Bridge',
    other: 'Other',
    betaHint:
      'The import is still in beta phase, which means that data is already being transferred securely and we are continuing to optimise the display. You can give us feedback and contact us via the support button on the right-hand side of the screen if you have any questions.',
    betaNotOptimalHint:
      'The import is still in beta phase, which means that all data is already being transferred securely, but the display for projects of this type is not yet optimal. You can give us feedback and contact us via the support button on the right-hand side of the screen if you have any questions.',
    projectTypeLabel: 'Project type',
  },
  sidebarTitle: 'Schedule imported',
  sidebarSubtitle: 'on {date} by {user} from the file {file} in {time}',
  sidebarHighlightsTitle: 'Highlights',
  sidebarHighlightsStructure:
    'Your schedule consists of {n} fewer lines compared to the original and is therefore more concise',
  sidebarHighlightsTrades: '1 trade was found and assigned | {n} trades were found and assigned',
  sidebarHighlightsCollisions:
    'We checked your original .mpp schedule and found {n} collisions | We found {n} collision in your original .mpp schedule - check and fix this to improve your schedule! | We found {n} collisions in your original .mpp schedule - check and fix this to improve your schedule!',
  sidebarHighlightsCollisionsPartialTextNoCollsions: 'zero',
  sidebarDataTitle: 'Data',
  startImport: 'Begin import',
  // summary card
  summaryCalendarsSuccess: 'All work schedules were successfully imported',
  summaryCalendarsTitle: 'Work schedules',
  summaryCalendarsIssueInvalidHeadline:
    '1 work schedule could not be imported | {n} work schedules could not be imported',
  summaryDependenciesSuccess: 'All dependencies were successfully imported',
  summaryDependenciesTitle: 'Dependencies',
  summaryDependenciesIssueInvalidHeadline:
    '1 dependency could not be imported | {n} dependencies could not be imported',
  summaryDependenciesIssueInvalidReasonInvalidConnector: 'Connector could not be found',
  summaryDependenciesIssueInvalidReasonDuplicate: 'Dependency exists multiple times',
  summaryDependenciesIssueInvalidReasonNonLeafConnector: 'Dependency between summary section',
  summaryDependenciesIssueInvalidReasonCyclic: 'Cyclic dependency found',
  summaryDependenciesIssueCollisionsHeadline:
    '1 new collision appeared | {n} new collisions appeared',
  summaryDependenciesIssueCollisionsReasonHourly: 'Transformation of hourly dates',
  summaryDependenciesIssueCollisionsHintHourly:
    'Usually, activities are planned in MS-Project with hourly times. In contrast, activities in koppla are only set on a daily basis. When transforming hourly times into daily times during the import, new collisions can occur.',
  summaryIssueGenericReason: 'Unknown error during import',
  summaryMilestonesSuccess: 'All milestones were successfully imported',
  summaryMilestonesTitle: 'Milestones',
  summaryMilestonesHint: 'Hint: You can search for milestones with {shortcut}',
  summaryMilestonesIssueInvalidHeadline:
    '1 milestone could not be imported | {n} milestones could not be imported',
  summaryMilestonesIssueInvalidReasonInvalidTrade: 'Trade could not be assigned',
  summaryMilestonesIssueInvalidReasonInvalidDate: 'Invalid date found',
  summaryMilestonesIssueInvalidReasonInvalidParent: 'Section could not be assigned',
  summaryOrdersSuccess: 'All activities were successfully imported',
  summaryOrdersTitle: 'Activities',
  summaryOrdersHint: 'Hint: You can search for activities with {shortcut}',
  summaryOrdersIssueInvalidHeadline:
    '1 activity could not be imported | {n} activities could not be imported',
  summaryOrdersIssueInvalidReasonInvalidTrade: 'Trade could not be assigned',
  summaryOrdersIssueInvalidReasonInvalidDateRange: 'Invalid start or end date found',
  summaryOrdersIssueInvalidReasonInvalidParent: 'Section could not be assigned',
  summaryOrdersIssueInvalidReasonInvalidCalendar: 'Work schedule could not be assigned',
  summaryTimeRangeSuccess: 'The total time range was successfully imported',
  summaryTimeRangeError: 'The total time range could not be correctly imported',
  summaryTimeRangeErrorExpectedPrefix: 'Original: ',
  summaryTimeRangeErrorActualPrefix: 'Imported: ',
  summaryTimeRangeErrorReason: 'Some activity dates could not be correctly imported',
  summaryTimeRangeTitle: 'Time range',
};
